import script from "./DevPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DevPanel.vue?vue&type=script&setup=true&lang=js"

import "./DevPanel.vue?vue&type=style&index=0&id=2d35ee54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d35ee54"]])

export default __exports__